class SurveyModel {
  static get STATUS() {
    return {
      PENDING: 1,
      ACTIVE: 2,
      IN_PROGRESS: 3,
      COMPLETED: 4,
      CANCELED: 5,
    }
  }
}

export default SurveyModel
